module.exports = __webpack_public_path__ + "img/soe@3x.d7867d7f.png";